module.exports = "https://coursera_assets.s3.amazonaws.com/images/cb34b7da0306cd192a510e9e30c0106f.png";